import { Icon } from '@scale/scaleui-radix';
import { Link } from 'react-router-dom';
import {
  faRectangleHistory,
  faShuffle,
  faToolbox,
  faBook,
  faSeedling,
  faPaperPlaneTop,
  faBullhorn,
  faWallet,
  faChartLineUp,
  faShieldCheck,
  faFolder,
  faCartShopping,
  faShelves,
  faTv,
  faPencil,
  faFlask,
  faCompass,
  faScrewdriverWrench,
  faClipboardCheck,
} from '@fortawesome/pro-solid-svg-icons';
import { faShield } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const ICON_MAP: Record<string, IconDefinition> = {
  'rectangle-history': faRectangleHistory,
  shuffle: faShuffle,
  toolbox: faToolbox,
  book: faBook,
  seedling: faSeedling,
  'paper-plane-top': faPaperPlaneTop,
  bullhorn: faBullhorn,
  wallet: faWallet,
  'chart-line-up': faChartLineUp,
  'shield-check': faShieldCheck,
  folder: faFolder,
  'cart-shopping': faCartShopping,
  shield: faShield,
  shelves: faShelves,
  tv: faTv,
  pencil: faPencil,
  flask: faFlask,
  compass: faCompass,
  'screwdriver-wrench': faScrewdriverWrench,
  'clipboard-check': faClipboardCheck,
};
export type HomeViewCardProps = {
  title: string;
  description: string;
  icon: keyof typeof ICON_MAP;
  to: string;
};

export function HomeViewCard({ title, description, icon, to }: HomeViewCardProps) {
  return (
    <Link
      className="flex flex-col items-center p-4 w-full bg-white border border-[rgba(20,0,53,0.1529)] rounded-lg isolate hover:shadow-md transition-shadow"
      to={to}
    >
      <div className="flex flex-col items-center gap-4 w-full">
        <div className="w-16 h-16 relative shrink-0">
          <div className="absolute inset-0 bg-[#F7F8FF] rounded-full" />
          <div className="absolute inset-0 flex justify-center items-center">
            <Icon
              icon={ICON_MAP[icon]}
              size="3"
              color="accent"
              label={title}
              className="w-8 h-8 text-[#6A5DF9]"
            />
          </div>
        </div>
        <div className="flex flex-col items-center gap-1 w-full">
          <div className="text-[20px] font-medium leading-[28px] text-center tracking-[-0.08px] text-[rgba(2,0,8,0.8784)]">
            {title}
          </div>
          <div className="text-[14px] font-normal leading-[20px] text-center text-[#65636D]">
            {description}
          </div>
        </div>
      </div>
    </Link>
  );
}
